import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { deletePendingTable, getAllPendingTables } from "../Redux/Actions/pendingTableActions";
import "./KitchenOrder.css";

function KitchenOrder() {
  const [orders, setOrders] = useState([]);
  const [orderCounter, setOrderCounter] = useState(1);
  const [products, setProducts] = useState([]);
  const [readyOrders, setReadyOrders] = useState([]);

  const dispatch = useDispatch();
  const pendingTables = useSelector((state) => state.pendingTableReducer.pendingTables);

  // Charger les commandes en attente
  useEffect(() => {
    dispatch(getAllPendingTables());
  }, [dispatch]);

  // Charger les produits
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("/api/Product/getAllProducts");
        setProducts(response.data);
      } catch (error) {
        console.error("Erreur lors du chargement des produits :", error);
      }
    };

    fetchProducts();
  }, []);

  // Charger les commandes payées et en attente
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get("/api/Bills/getAllBills");
        const paidOrders = response.data
          .filter((bill) => bill.status === "paid")
          .map((bill, index) => ({
            orderId: bill._id,
            orderNumber: orderCounter + index,
            tableNumber: bill.tableNumber,
            confirmationDate: new Date(bill.date), // Assurez-vous que c'est un objet Date
            items: bill.items,
            status: "paid",
          }));

        const pendingOrders = Object.values(pendingTables).map((table, index) => ({
          orderId: table.tableNumber,
          orderNumber: orderCounter + paidOrders.length + index,
          tableNumber: table.tableNumber,
          confirmationDate: new Date(table.createdAt), // Assurez-vous que c'est un objet Date
          items: table.items,
          status: "pending",
        }));

        setOrders([...paidOrders, ...pendingOrders]);
        setOrderCounter((prev) => prev + paidOrders.length + pendingOrders.length);
      } catch (error) {
        console.error("Erreur lors du chargement des commandes :", error);
      }
    };

    fetchOrders();
  }, [pendingTables]);

  // Charger les commandes prêtes
  useEffect(() => {
    const fetchReadyOrders = async () => {
      try {
        const response = await axios.get("/api/ReadyOrders/getAllReadyOrders");
        setReadyOrders(response.data);
      } catch (error) {
        console.error("Erreur lors du chargement des commandes prêtes :", error);
      }
    };

    fetchReadyOrders();
  }, []);

  // Récupérer la catégorie d'un sous-produit
  const getCategory = (subProductId) => {
    const product = products.find((prod) =>
      prod.subProducts.some((sub) => sub._id?.toString() === subProductId?.toString())
    );
    return product ? product.category : "Non catégorisé";
  };

  const getProductName = (subProductId) => {
    const product = products.find((prod) =>
      prod.subProducts.some((sub) => sub._id?.toString() === subProductId?.toString())
    );
    return product ? product.name : "Produit inconnu";
  };

  // Marquer une commande comme prête
  const handleOrderReady = async (order) => {
    try {
      const { orderId, tableNumber, items, confirmationDate, orderNumber } = order;

      const newOrder = {
        orderId,
        tableNumber,
        items,
        readyTime: new Date(), // Envoyer un objet Date
        confirmationDate: new Date(confirmationDate), // Convertir en objet Date
        orderNumber,
        isReady: true,
      };

      // Envoyer la commande au serveur
      await axios.post("/api/ReadyOrders/addReadyOrder", newOrder);

      // Mettre à jour l'état local
      setOrders((prev) => prev.filter((o) => o.orderId !== orderId)); // Retirer la commande de la liste
      setReadyOrders((prev) => [...prev, newOrder]);

      alert("Commande marquée comme prête !");
    } catch (error) {
      console.error("Erreur lors de la mise en prêt de la commande :", error);
    }
  };

  // Filtrer les commandes FOOD uniquement
  const filteredOrders = orders.filter((order) =>
    order.items.some((item) => getCategory(item.id) === "FOOD")
  );

  return (
    <div className="kitchen-order-container">
      <h2>Ordres Cuisine</h2>
      <table className="order-table">
        <thead>
          <tr>
            <th>Numéro de commande</th>
            <th>Numéro de table</th>
            <th>Date de confirmation</th>
            <th>Nature de la commande</th>
            <th>Catégorie</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredOrders.map((order) => (
            <tr key={order.orderId}>
              <td>{order.orderNumber}</td>
              <td>{order.tableNumber}</td>
              <td>
                {order.confirmationDate && order.confirmationDate instanceof Date
                  ? order.confirmationDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
                  : "Date invalide"}
              </td>
              <td>
                <ul>
                  {order.items.map((item, idx) => (
                    <li key={idx}>
                      {getProductName(item.id)} - {item.name} x {item.quantity}
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                <ul>
                  {order.items.map((item, idx) => (
                    <li key={`${order.orderId}-cat-${idx}`}>{getCategory(item.id)}</li>
                  ))}
                </ul>
              </td>
              <td>
                <button onClick={() => handleOrderReady(order)}>Prêt</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default KitchenOrder;